
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"active-highlight",attrs:{"d":"M22.937 4.817A10.587 10.587 0 0014.046 0a.478.478 0 00-.478.478v10.134a.478.478 0 00.739.4l8.49-5.533a.479.479 0 00.14-.662zM14.524 9.73V.968a9.628 9.628 0 017.34 3.977l-7.34 4.785z","fill":"#E2E4EC"}}),_c('path',{attrs:{"d":"M21.503 7.592a.478.478 0 00-.661-.139l-7.752 5.052V3.253a.478.478 0 00-.478-.478c-2.421 0-4.79.838-6.67 2.36A10.573 10.573 0 002 13.388c0 2.834 1.104 5.5 3.108 7.504A10.543 10.543 0 0012.612 24c2.835 0 5.5-1.104 7.504-3.108a10.543 10.543 0 003.109-7.504c0-2.067-.596-4.071-1.722-5.796zm-9.369-3.848v8.292l-5.212-6.45a9.686 9.686 0 015.212-1.843zm.478 19.3c-5.324 0-9.656-4.332-9.656-9.656a9.616 9.616 0 013.223-7.2l6.062 7.5c.154.19.427.234.633.1l8.08-5.266a9.619 9.619 0 011.315 4.866c0 5.324-4.332 9.656-9.657 9.656z","fill":"#00003C"}}),_c('path',{attrs:{"d":"M18.489 11.721a.478.478 0 00-.662-.14l-3.112 2.028a.478.478 0 00.523.8l3.111-2.026a.478.478 0 00.14-.662zM19.96 10.763a.478.478 0 00-.661-.14l-.168.11a.478.478 0 00.522.8l.168-.109a.478.478 0 00.14-.661z","fill":"#E2E4EC"}})])
          )
        }
      }
    